import { CircularProgress, Grid, TextField } from "@material-ui/core";
import React from "react";
import classes from "./index.module.scss";
import People from "../../../assets/images/leftcontent.png";
import styled from "styled-components";

export function FirstContent(props: { onSubmit: (secuityNo: string) => void }) {
  const [secuityNo, setSecuityNo] = React.useState<string>("");
  const [loadingBtn, setLoadingbtn] = React.useState<boolean>(false);
  const goToInvoiceslist = async () => {
    setLoadingbtn(true);
    await props.onSubmit(secuityNo);
    // setSecuityNo("");
    setLoadingbtn(false);
  };

  return (
    <section className={classes.wrapper}>
      <div className={classes.thanksInfo}>
        <p>
          <b>Công ty TNHH Bảo hiểm nhân thọ Prudential Việt Nam</b> xin trân
          trọng cảm ơn Quý khách đã sử dụng dịch vụ của chúng tôi.
        </p>
      </div>
      <div className={classes.mainContent}>
        <Grid container>
          <Grid item xs={12} md={6}>
            <div className={classes.leftContent}>
              <img src={People} alt="People" />
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div className={classes.rightContent}>
              <StyledInput>
                <p>
                  Để hiển thị file hóa đơn quý khách vui lòng nhập mật khẩu là
                  số chứng minh nhân dân hoặc căn cước công dân đã cung cấp với
                  Prudential trước đây vào ô bên dưới.
                </p>
                <TextField
                  variant="outlined"
                  fullWidth
                  type="text"
                  value={secuityNo}
                  onChange={(e) => setSecuityNo(e.target.value as string)}
                />
                <div>
                  {loadingBtn ? (
                    <div className={classes.loadingBtn}>
                      <CircularProgress />
                    </div>
                  ) : (
                    <button
                      className={classes.button}
                      disabled={secuityNo ? false : true}
                      onClick={() => goToInvoiceslist()}
                    >
                      Xác nhận
                    </button>
                  )}
                </div>
              </StyledInput>
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
}

const StyledInput = styled.div`
  .MuiInputBase-root {
    background-color: #fff;
  }
`;
